import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Slider from "react-slick";
import { Link } from 'react-router-dom';

function SuperChickenRushPromoFun(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    return (
        <>
            <InformationWrapper>
                    <TitleText>
                        <p>30 Days of <span className='brandColor'>₹3,000 Cash</span> on Uncrossable Rush - play daily & unlock more winnings.</p>
                    </TitleText>
                <ImageWrapper>
                    <Container>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                           <Link to='/slots/evoplay/uncrossable-rush' className='playNowBtn'><span>Play Now</span></Link>
                    </Container>
                </ImageWrapper> 

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon1}`}/>
                            <p>Play Uncrossable Rush daily on FUN88.</p>
                        </KeyDetailsSecBox>
                             
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon2}`}/>
                            <p>Spin the required number of rounds to unlock Free Cash.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon3}`}/>
                            <p>Claim up to ₹3,000 Free cash every day.</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <PriceBreakDown>
                    <MainTitle>How Free Cash Unlocks?</MainTitle>
                    <SliderWrapper>
                        <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushFreeRoundPrice}`}
                                alt="How Free Cash Unlocks"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                    </SliderWrapper>
                </PriceBreakDown>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>✪ Only bets of ₹75 or more per spin qualify.</li>
                        <li>✪ Winnings from Free Cash capped at 1x per day.</li>
                        <li>✪ Maximum of ₹3,000 per day per player.</li>
                        <li>✪ Standard brand T&Cs apply.</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(SuperChickenRushPromoFun));

const TermsAndCondition = styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 8px;
    border: ${theme('palette.weeklySepLeaderboardTCBorder')};
    background: ${theme('palette.weeklySepLeaderboardTCBg')};
    padding: 1rem;
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #444;
            font-size: 16px;
            text-transform: capitalize;
        }
    }
`;

const SliderWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 738px;
        max-width: 100%;
    }
`;

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1.5rem 0 1rem 0;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: #EBEBEB;
    overflow: hidden;

    .boldText {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .brandColor {
        color: ${theme('palette.suprChknRushBrandTextColor')};
        font-weight: 700;
    }
`;

const PriceBreakDown = styled.div`
    width: 70%;
    padding: 2rem 0 2rem 0;
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 1rem auto 0 auto;
`;



const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    gap: 15px;
    margin-bottom: 2rem;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;
    width: 70%;
    margin: auto;


    p {
        color: #000;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        margin: 0;
        text-transform: capitalize;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;
    width: 70%;
    margin: 1em auto 0 auto;
`;


const Container = styled.div`
    width: 275px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

    .playNowBtn {
        width: 220px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 1.5rem;
        border-radius: 60px;
        border: ${theme('palette.suprChknRushPlayNowBtnBorder')};
        background: ${theme('palette.suprChknRushPlayNowBtnBgColor')};

        :hover {
            background: #04a6ff;
            border: 3px solid #0f7db9;
        }
    }
`;

const MainTitle = styled.h4`
        color: #06A6FF;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 35px; /* 175% */
        text-transform: capitalize;
        margin: 3px 0px 15px 0px;
`


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
    background-color: #fff;
    padding: 1em 0;
    border-radius: 8px;
    
`

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    padding-bottom: 1rem;
`

const KeyDetailsSecBox = styled.div`
    width: 23%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: 6px;
    border: 0.5px solid #8CD6FF;
    background: #06A6FF;

    img {
        width: 61px;
    }

    & p {
        color: #fff;
        text-align: center;
        font-size: 17px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`